import React from 'react';

const Edit = () => {
    return (
        <div>
            Edit photo
        </div>
    );
};

export default Edit;